/**
 * Settle with `promise`, or reject with `makeError()` once `ms` elapse — whichever comes first. The
 * timer is always cleared. The underlying work is NOT cancelled (a promise cannot be); callers must
 * tolerate it finishing later.
 */
export const withTimeout = <T>(
  promise: Promise<T> | T,
  ms: number,
  makeError: () => Error
): Promise<T> => {
  let timer: ReturnType<typeof setTimeout> | undefined
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(makeError()), ms)
  })
  return Promise.race([Promise.resolve(promise), timeout]).finally(() => clearTimeout(timer))
}
